import { Button, Flex, Modal, Typography } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { getSystemVersion } from '@/services';
import Settings from '../../../config/defaultSettings';

const { Title, Paragraph } = Typography;

export default function VersionModal() {
  const [version, setVersion] = useState<API.SYSTEM.Version>();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    getVersion();
  }, [open]);

  const getVersion = async () => {
    try {
      const { code, msg, data } = await getSystemVersion();
      if (code === 200) {
        setVersion(data);
      } else {
        console.error('获取版本信息失败:', msg);
      }
    } catch (error) {
      console.error('获取版本信息失败:', error);
    }
  };

  return (
    <>
      {version ? (
        <Button type="text" size="small" onClick={() => setOpen(true)}>
          v{version?.versionCode || '1.0'}
        </Button>
      ) : null}
      <Modal
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
      >
        <Flex
          align="center"
          justify="center"
          vertical
          gap={32}
          style={{ textAlign: 'center' }}
        >
          <div>
            <Title level={3}>{Settings.title}</Title>
          </div>
          <div>
            {version?.versionName ? (
              <Paragraph type="secondary">{version.versionName}</Paragraph>
            ) : null}
            <Paragraph type="secondary">
              版本号：v{version?.versionCode || '1.0'}
            </Paragraph>
            <Paragraph type="secondary">{version?.remark}</Paragraph>
          </div>
          <Paragraph>© {dayjs().year()} 森启智能</Paragraph>
        </Flex>
      </Modal>
    </>
  );
}
